import { makeVar, useReactiveVar } from '@apollo/client';
import kebabCase from 'lodash/kebabCase';

const downloadsVar = makeVar([]);

type queueDownloadParameters = {
  href: string;
  fileName: string;
  fileExtension?: '.csv' | '.pdf';
};

export const queueDownload = ({
  href,
  fileName,
  fileExtension = '.csv',
}: queueDownloadParameters) => {
  const active = downloadsVar();
  if (active.map((x) => x.href).includes(href)) return;
  downloadsVar([...active, { href, fileName: `${kebabCase(fileName)}${fileExtension}` }]);
};

export const clearDownload = (href) => downloadsVar(downloadsVar().filter((x) => x.href !== href));

export const useDownloads = () => useReactiveVar(downloadsVar);
